<template lang="pug">
  div
    page_header(title="Startups", subhead="Edit")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "startups.index"}')
        i.feather-arrow-left
        | Back
    
    .row
      .col-sm-12
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-6
                form_input(type="text" name="name" label="Name" placeholder="Enter Startup Name" v-model="form.name")             
                form_input(type="text" name="address" label="Address" placeholder="Enter Address" v-model="form.address")
                form_input(type="text" name="incubator" label="Incubator" placeholder="Enter Incubator" v-model="form.incubator")
                form_input(type="date" name="incorporation" label="Date of Incoporation" placeholder="Enter Incoporation" v-model="form.incorporation")
                form_input(type="text" name="dipp" label="DIPP No" placeholder="Enter Dipp No" v-model="form.dipp")
                form_input(type="text" name="uid" label="KSUM Unique ID" placeholder="Enter KSUM UID" v-model="form.uid")
                form_input(type="url" name="brochure" label="Brochure Link" placeholder="Brochure Link" v-model="form.brochure")
                form_input(type="url" name="pitch_video" label="Pitch Video Link" placeholder="Pitch Video Link" v-model="form.pitch_video")

              .col-sm-6      
                form_input(type="text" name="district" label="District" placeholder="Enter District" v-model="form.district")
                
                form_input(type="url" name="website" label="Website" placeholder="Enter Website" v-model="form.website")
                form_input(type="url" name="linkedin" label="LinkedIn" placeholder="LinkedIn URL" v-model="form.linkedin") 
                
                //logo
                imageSelect(v-model="form.logo" :h="281" :w="500" modal_class="modal-lg")

            .row
              .col-sm-12
                .mb-3
                  label.form-label Brief
                  textarea.form-control(v-model="form.brief" rows="5" maxLength="500")

            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import imageSelect from '@/components/imageSelect'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Startups',
  props: ['id'],
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn,
    imageSelect
  },
  data(){
    return {
      roles: [],
      form: {

      }
    }
  },
  computed: {
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    submit(){
      var vm = this;
      this.call({_vm:this, endpoint: 'admin/startups/'+this.id, method: 'PUT', data: this.form})
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: `admin/startups/${this.id}/edit`, method: 'GET'}).then((response)=>{
      vm.form = {
        name: response.data.name,
        address: response.data.address,
        district: response.data.district,
        website: response.data.website,
        linkedin: response.data.linkedin,
        incorporation: response.data.incorporation,
        incubator: response.data.incubator,
        dipp: response.data.dipp,
        uid: response.data.uid,
        logo: response.data.logo,
        brochure: response.data.brochure,
        pitch_video: response.data.pitch_video,
        brief: response.data.brief,
      };
    })
  }
}
</script>
